<template>
  <div class="md:py-4 md:w-80">
    <div class="mx-auto max-w-rxl sm:px-6 lg:px-8">
      <div class="overflow-hidjen bg-white shadow-xl p-7 sp:p-3 border-solid border border-gray-200">
        <div class="w-full text-right">
          <template v-if="questionListMenu">
            <button
              v-if="onResize"
              class="bg-gray-500 lg:hover:bg-gray-300 active:bg-gray-300 duration-300 text-white py-3 px-4 text-xs my-1 rounded-lg"
              @click="onClickedQuestionListMenu">
              <p class="flex items-center">
                解答リスト
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                    clip-rule="evenodd" />
                </svg>
              </p>
            </button>
          </template>
        </div>
        <div class="bg-gray-100 rounded-lg border-2 border-gray-500">
          <question-list
            :all-questions="allQuestions"
            :type="type"
            :examination="examination"
            :question-answers="questionAnswers"
            :question-index="questionIndex"
            :all-answer-question-answers="allAnswerQuestionAnswers"
            :is-clicked-question-list="isClickedQuestionList"
            @set-index="setIndex" />
        </div>
        <button
          class="bg-red-500 lg:hover:bg-red-300 active:bg-red-300 duration-300 text-white py-2.5 px-6 sp:py-3 sp:px-4 sp:text-sm mt-3 rounded-lg"
          @click="$emit('confirmation')">
          解説ページを閉じる
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import QuestionList from './QuestionList'

const props = defineProps({
  allQuestions: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: String,
    default: null,
  },
  countAnswer: {
    type: Number,
    default: 0,
  },
  questionAnswers: {
    type: Array,
    default: () => [],
  },
  isClickedQuestionList: {
    type: Boolean,
    default: false,
  },
  onResize: {
    type: Boolean,
    default: false,
  },
  questionListMenu: {
    type: Boolean,
    default: false,
  },
  allAnswerQuestionAnswers: {
    type: Object,
    default: () => ({}),
  },
  questionIndex: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['confirmation', 'on-clicked-question-list-menu', 'set-index'])
const setIndex = (value) => emit('set-index', value)
const onClickedQuestionListMenu = () => {
  emit('on-clicked-question-list-menu')
}

const refColor = ref('black')
const isChangeColor = ref(false)
const setBgColor = () => {
  isChangeColor.value = !isChangeColor.value
  if (isChangeColor.value) {
    refColor.value = 'red'
  } else {
    refColor.value = 'black'
  }
}
</script>
